import ShieldTickIcon from "@redotech/redo-icons/shield-tick.svg";
import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export interface SubmitWarrantyRegistrationState {
  customTitle?: string;
}

export const SUBMIT_WARRANTY_REGISTRATION = (
  Details: React.ComponentType<
    StepTypeDetailsProps<SubmitWarrantyRegistrationState>
  >,
): StepType<
  SubmitWarrantyRegistrationState,
  ModelStep.SubmitWarrantyRegistration
> => ({
  Details: (props: StepTypeDetailsProps<SubmitWarrantyRegistrationState>) =>
    React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  title: "Submit Warranty Registration",
  valid: () => true,
  Icon: ShieldTickIcon,
  description(state) {
    return "Submit warranty registration";
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: {},
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SUBMIT_WARRANTY_REGISTRATION,
    };
  },
  fromModel(model) {
    return { customTitle: model.customTitle };
  },
});
